/* =====================================================================
   Bailey & Beau Co. — Home page interactions
   ===================================================================== */

/**
 * Handles the contact / newsletter form submissions.
 * Prevents a real navigation, gives lightweight "Sent" feedback,
 * and resets the form.
 * @param {Event} e
 * @param {HTMLFormElement} form
 * @returns {boolean}
 */
function handleSubmit(e, form) {
  e.preventDefault();

  const label = form.querySelector('[data-label]');
  if (label) {
    const original = label.textContent;
    label.textContent = 'Sent ✓';
    form.reset();
    setTimeout(function () {
      label.textContent = original;
    }, 2200);
  }
  return false;
}

// Expose for inline onsubmit handlers in the markup.
window.handleSubmit = handleSubmit;

/* =====================================================================
   Decorative particles — recolor each shape at a random 2–5s cadence
   ===================================================================== */
(function () {
  var palettes = {
    vivid: ['#F26B59', '#F0C75E', '#46AFCE', '#9E7DBB', '#C84A70', '#41BA85'],
    light: ['#FFFFFF', '#F0C75E', '#7FD3E8', '#F26B59', '#E59BC0', '#FBE0A8'],
  };

  function pick(arr, exclude) {
    var c;
    do { c = arr[Math.floor(Math.random() * arr.length)]; }
    while (c === exclude && arr.length > 1);
    return c;
  }

  function start() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var parts = document.querySelectorAll('.deco');
    parts.forEach(function (p) {
      var pal = palettes[p.dataset.palette] || palettes.vivid;
      // seed an initial colour immediately so there's no flash
      p.style.color = pick(pal);
      if (reduce) return;
      (function loop() {
        var delay = (2 + Math.floor(Math.random() * 4)) * 1000; // 2,3,4 or 5s
        setTimeout(function () {
          p.style.color = pick(pal, p.style.color);
          loop();
        }, delay);
      })();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
